import { z } from 'zod'

import { schemas } from '~interface/zod-schema'

export enum IAIInteractionType {
  SEARCH = 'SEARCH',
  CHAT = 'CHAT',
  VOICE = 'VOICE',
  SMS = 'SMS',
  EMAIL = 'EMAIL',
}

export enum SourceType {
  SourceWebsite = 'SourceWebsite',
  SourceDocument = 'SourceDocument',
  SourceFAQ = 'SourceFAQ',
  SourceAPI = 'SourceAPI',
  SourceTransferLine = 'SourceTransferLine',
  SourcePoliProcess = 'SourcePoliProcess',
}
export type Query = z.infer<typeof schemas.Query>
export type QueryAnalysis = z.infer<typeof schemas.QueryAnalysis>
export type QueryTypeEnum = z.infer<typeof schemas.QueryTypeEnum>
export type Response = z.infer<typeof schemas.Response>
export type ChatDisplaySource = z.infer<typeof schemas.ChatDisplaySource>
export type AIInteractionLog = z.infer<typeof schemas.AIInteractionLog>
export type Chunk = z.infer<typeof schemas.Chunk>
export type Page = z.infer<typeof schemas.Page>
export type AIInteractionSummary = z.infer<typeof schemas.AIInteractionSummary>
export const ResponseTypeEnum = schemas.ResponseTypeEnum
export type ResponseTypeEnumType = z.infer<typeof ResponseTypeEnum>

export interface IChatMessageDisplay {
  id: string | null
  text: string
  sender: 'USER' | 'AI' | 'ACTION'
  timestamp: Date
  impression: boolean | null
  responseType?: ResponseTypeEnumType
  sources?: ChatDisplaySource[]
  queryAnalysis?: QueryAnalysis | null
  relevantChunks?: Chunk[] | null
}

export interface IQuery {
  id: string
  chatId: string
  body: string
  created: Date
}

export interface IResponse {
  id: string
  chatId: string
  body: string
  created: Date
  impression?: boolean
}

export interface IChat {
  id: string
  organizationId: string
  userId: string
  created: Date
  caseId?: string
  queries: IQuery[]
  responses: IResponse[]
  type: IAIInteractionType
}
